import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#151515",
  "fill-rule": "evenodd",
  d: "M12.598 2.199a1 1 0 0 0-1.196 0L11.4 2.2l-.013.01-.058.041q-.077.057-.221.158c-.192.134-.461.318-.772.515-.642.406-1.388.824-1.98 1.02-.879.288-2.405.6-3.356.77l-.008.002a1.96 1.96 0 0 0-1.606 1.92v8.196c0 1.3.654 2.392 1.463 3.248.811.86 1.86 1.57 2.855 2.128 1.003.563 2 .998 2.74 1.29a23 23 0 0 0 1.23.446l.02.007.006.001.002.001L12 21l-.299.954a1 1 0 0 0 .595 0L12 21l.297.955h.001l.008-.003.02-.006.329-.11c.22-.076.53-.189.902-.335.74-.292 1.736-.725 2.74-1.286.995-.558 2.044-1.267 2.855-2.125.81-.856 1.463-1.948 1.463-3.248V6.638c0-.942-.673-1.76-1.613-1.922-.968-.184-2.482-.484-3.357-.771-.591-.196-1.338-.614-1.98-1.02a20 20 0 0 1-.993-.673l-.057-.041-.014-.01zm-.597 17.747c.197-.069.48-.171.822-.306a21 21 0 0 0 2.496-1.17c.909-.509 1.764-1.102 2.38-1.754.619-.655.916-1.28.916-1.874V6.678c-.939-.178-2.578-.5-3.595-.833l-.003-.001c-.836-.278-1.755-.807-2.421-1.23-.222-.14-.424-.274-.596-.39-.172.116-.374.25-.595.39-.667.423-1.586.952-2.422 1.23H8.98c-1.013.334-2.639.662-3.595.834v8.154c0 .596.298 1.22.917 1.876.616.653 1.472 1.248 2.38 1.757.9.505 1.808.902 2.496 1.174.342.135.626.238.823.307",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF760A",
  "fill-rule": "evenodd",
  d: "M16.128 9.177a1 1 0 0 1 .08 1.412l-4.327 4.846a1 1 0 0 1-1.429.065l-2.596-2.423a1 1 0 0 1 1.365-1.462l1.849 1.725 3.646-4.083a1 1 0 0 1 1.412-.08",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }